import { Link } from 'react-router-dom';
import BrandLogo from './BrandLogo';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__brand">
          <BrandLogo size="sm" />
          <span>Sarthi</span>
        </div>
        <p>Instant city rides and hire-a-car travel with a trusted driver fleet.</p>
        <nav className="footer__legal" aria-label="Legal and support">
          <Link to="/privacy">Privacy Policy</Link>
          <span aria-hidden="true">·</span>
          <Link to="/support">Support</Link>
        </nav>
        <p className="footer__copy">
          © {new Date().getFullYear()} Sarthi Taxi Hiring. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
